import PropTypes from 'prop-types';
import { FieldType } from './FieldType';

export const ErrorType = {
    DATE: FieldType.DATE,
    DEPARTURE: FieldType.DEPARTURE,
    ARRIVAL: FieldType.ARRIVAL,
    ROOM: FieldType.ROOM,
    SEPARATE_STAY: FieldType.SEPARATE_STAY,
};

export const ProductManagerErrorProp = PropTypes.shape({
    error: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(ErrorType)).isRequired,
    index: PropTypes.number,
});
